import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 15h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 11h12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "JapaneseYen";
const JapaneseYen = memo(themed(Icon));
export {
  JapaneseYen
};
//# sourceMappingURL=japanese-yen.js.map
